module.exports = __webpack_public_path__ + "img/quizz-step-8-2.957b1326.jpg";